
import dialogShell from '@/components/common/dialog-shell/index.vue';
import HttpRequest from '@/util/axios.config';
import {
    defineComponent, ref, Ref, PropType, reactive
} from 'vue';
import { DeviceFormData } from '@/components/view/pm/device-edit-dialog/all.type';
import { checkSpecialCharacters } from '@/methods/rules/device';
import relay from '@/components/view/common/relay';
import { ChangeWordList } from '@/methods/setText';
import { device } from '@/data';
import { isNew, ProjectType } from '@/data/src/community';

export default defineComponent({
    components: {
        dialogShell,
        relay
    },
    props: {
        initForm: {
            type: Object as PropType<DeviceFormData>,
            required: true
        },
        projectType: {
            type: String as PropType<ProjectType>,
            default: 'community'
        }
    },
    setup(props, { emit }) {
        const deviceEditFormRef: Ref<any> = ref();
        const formData = reactive({ ...props.initForm });
        const rules = {
            Location: [{
                required: true,
                message: WordList.RuleLocationEmpty,
                trigger: 'change'
            }, {
                validator: checkSpecialCharacters,
                trigger: 'change'
            }]
        };

        const close = () => {
            emit('close');
        };
        const submit = (relayValue: string, securityRelayValue: string) => {
            const param = { ...formData };
            param.Relay = relayValue;
            if ((isNew.value && ProjectType.value === 'community') || ProjectType.value === 'office') {
                param.SecurityRelay = securityRelayValue;
            }
            HttpRequest.post(
                ProjectType.value === 'community'
                    ? 'v3/web/community/device/editForPm'
                    : 'v3/web/office/device/editForPm',
                param, () => {
                    emit('success');
                    close();
                }
            );
        };
        const commit = ref(0);
        const checkValid = () => {
            deviceEditFormRef.value.validate((valid: boolean) => {
                if (valid) {
                    if (formData.Type === device.managementPhone) {
                        submit('', '');
                    } else {
                        commit.value += 1;
                    }
                }
            });
        };

        return {
            formData,
            checkValid,
            submit,
            close,
            deviceEditFormRef,
            rules,
            commit,
            ChangeWordList,
            isNew,
            ProjectType
        };
    }
});

